export default "__VITE_ASSET__BiZfrgch__"